"use strict"

import Organization from "../../app/model/domain/organization"
import {
  SubscriptionCoupons,
  SubscriptionPlans,
} from "../../app/model/domain/subscription"

import AuthService, {
  UserTokenInfo,
} from "../../app/services/auth/auth.service"
import BreadcrumbService from "../../app/services/breadcrumb-service/breadcrumb.service"
import IncentiveService from "../../app/services/incentive/incentive.service"
import OrganizationService from "../../app/services/organization/organization.service"

import { ColleagueSuggestion } from "./ColleagueInput"
import { FinancialFormData } from "./SubscriptionFinancialAid"

interface OrganizationData {
  organizationId: string
  mdrPeers: ColleagueSuggestion[]
}

export class SubscriptionFinancialAidController {
  private user: UserTokenInfo
  private organization?: Organization[]
  private mdrPeers: ColleagueSuggestion[] = []
  private incentiveId: string

  constructor(
    private AuthService: AuthService,
    private BreadcrumbService: BreadcrumbService,
    private IncentiveService: IncentiveService,
    private OrganizationService: OrganizationService,
  ) {
    "ngInject"

    this.user = this.AuthService.authData

    this.incentiveId = "assignment-limit-v2"

    // Bind methods that will be passed to React components
    this.loadOrganizationData = this.loadOrganizationData.bind(this)
    this.submit = this.submit.bind(this)
    this.goToSubscriptionPage = this.goToSubscriptionPage.bind(this)

    if (!this.user?.isTeacher) {
      this.BreadcrumbService.go("root.account.home")
      return
    }
  }

  async loadOrganizationData(): Promise<OrganizationData> {
    if (!this.user) {
      throw new Error("User not authenticated")
    }

    // Only fetch if not already loaded
    if (!this.organization) {
      this.organization = await this.OrganizationService.getForUser(
        this.user.id,
      )

      if (this.organization?.[0]) {
        this.mdrPeers =
          await this.OrganizationService.getMdrPeersNotInOrgWithNames(
            this.organization[0].id,
          )
      }
    }

    return {
      organizationId: this.organization?.[0]?.id || "",
      mdrPeers: this.mdrPeers,
    }
  }

  async submit(data: FinancialFormData): Promise<void> {
    if (!this.organization?.[0]) {
      throw new Error("Organization data not loaded")
    }

    const submissionData = {
      ...data,
      submittedAt: new Date().toISOString(),
    }

    const postBody = {
      organizationId: this.organization[0].id,
      emails: submissionData.invitedColleagues,
    }

    // Add admin information into organization_admin table
    await this.OrganizationService.addAdmin(
      this.organization[0].id,
      submissionData.name,
      submissionData.email,
      submissionData.role,
    )
    // Invite Colleague Incentive
    await this.IncentiveService.save(this.incentiveId, postBody)
  }

  goToSubscriptionPage(): void {
    this.BreadcrumbService.go("root.account.create-payment", {
      tierId: SubscriptionPlans.NiagaraMonthlyV9,
      couponCode: SubscriptionCoupons.FINAID75,
    })
  }

  getFinancialAidCoupon(): string {
    return SubscriptionCoupons.FINAID75
  }
}
